import { DataIntegrityValidationErrorResolutionStatusEnum } from './data-integrity-validation-error-resolution-status-enum.generated';

const x: { [index: string]: string } = {};
x[DataIntegrityValidationErrorResolutionStatusEnum.None] = 'None';
x[DataIntegrityValidationErrorResolutionStatusEnum.Unresolved] = 'Unresolved';
x[DataIntegrityValidationErrorResolutionStatusEnum.AutomaticallyResolved] = 'Automatically Resolved';
x[DataIntegrityValidationErrorResolutionStatusEnum.ManuallyResolved] = 'Manually Resolved';
x[DataIntegrityValidationErrorResolutionStatusEnum.Relapsed] = 'Relapsed';
x[DataIntegrityValidationErrorResolutionStatusEnum.InProgress] = 'In Progress';
export const DataIntegrityValidationErrorResolutionStatusEnumDescriptions: { [indexer: string]: string } = x;
